import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isWxAndroid: false,
  },
  mutations: {
    ["SET_IS_WX_ANDROID"](state, payload) {
      state.isWxAndroid = payload;
    },
  },
  actions: {},
  modules: {},
});
